import 'react-slidedown/lib/slidedown.css';
import './styles.scss';

import * as React from 'react';

import Packages, { PackagesProps } from './Packages';

import classnames from 'classnames';

const SlideDown = require('react-slidedown').SlideDown;

export interface State {
    isShown: boolean;
}

export interface Props extends PackagesProps {
    onSectionExpanded?: () => void;
    isShown: boolean;
}

export default class ServiceOptions extends React.Component<Props, State> {
    public state = {
        isShown: false,
    };

    constructor(props: Props) {
        super(props);
        this.handleToggleClick = this.handleToggleClick.bind(this);
        this.handleSectionExpanded = this.handleSectionExpanded.bind(this);
    }

    public render() {
        return (
            <div className='VenuePage--detail VenuePage--detail__expandable'>
                <div className='VenuePage--detail-headline-container' onClick={this.handleToggleClick}>
                    <h3 className='VenuePage--detail-headline VenuePage--detail-headline__expandable'>
                        Packages
                        <i
                            className={classnames('icon-hb-nx-arrow-down-16', { 'icon-hb-nx-arrow-down-16__flipped': this.state.isShown })}
                        />
                    </h3>
                </div>

                <div className='VenuePage--additional-detail-container'>
                    <SlideDown className={'VenuePage--row'}>{this.state.isShown && this.renderContent()}</SlideDown>
                </div>
            </div>
        );
    }

    private renderContent() {
        return [
            <Packages key={0} {...this.props} />
        ];
    }

    private handleSectionExpanded() {
        if (this.props.onSectionExpanded) {
            this.props.onSectionExpanded();
        }
    }

    private handleToggleClick() {
        const trigger = !this.state.isShown;
        this.setState({ isShown: !this.state.isShown });

        if (trigger) {
            this.handleSectionExpanded();
        }
    }
}
